/**
 * @generated SignedSource<<10f393daa7efc945178136c97c779533>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GamingQuery$variables = {};
export type GamingQuery$data = {
  readonly gaming: {
    readonly " $fragmentSpreads": FragmentRefs<"Offers_offers">;
  } | null;
  readonly gamingPromos: {
    readonly " $fragmentSpreads": FragmentRefs<"OfferPromoBanner_promos">;
  } | null;
};
export type GamingQuery = {
  variables: GamingQuery$variables;
  response: GamingQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "requiredTags": [
        "gaming"
      ]
    }
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "requiredTags": [
        "gaming",
        "promo"
      ]
    }
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paysReward",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardLabel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GamingQuery",
    "selections": [
      {
        "alias": "gaming",
        "args": (v0/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "cashbacks",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Offers_offers"
          }
        ],
        "storageKey": "cashbacks(input:{\"requiredTags\":[\"gaming\"]})"
      },
      {
        "alias": "gamingPromos",
        "args": (v1/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "cashbacks",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OfferPromoBanner_promos"
          }
        ],
        "storageKey": "cashbacks(first:1,input:{\"requiredTags\":[\"gaming\",\"promo\"]})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GamingQuery",
    "selections": [
      {
        "alias": "gaming",
        "args": (v0/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "cashbacks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Advertiser",
                    "kind": "LinkedField",
                    "name": "advertiser",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "categories",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tag",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tags",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": "cashbacks(input:{\"requiredTags\":[\"gaming\"]})"
      },
      {
        "alias": "gamingPromos",
        "args": (v1/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "cashbacks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "desktopImageUrl",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Advertiser",
                    "kind": "LinkedField",
                    "name": "advertiser",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": "cashbacks(first:1,input:{\"requiredTags\":[\"gaming\",\"promo\"]})"
      }
    ]
  },
  "params": {
    "cacheID": "df9c67f5185fef81e0dcbf69c289f073",
    "id": null,
    "metadata": {},
    "name": "GamingQuery",
    "operationKind": "query",
    "text": "query GamingQuery {\n  gaming: cashbacks(input: {requiredTags: [\"gaming\"]}) {\n    ...Offers_offers\n    id\n  }\n  gamingPromos: cashbacks(input: {requiredTags: [\"gaming\", \"promo\"]}, first: 1) {\n    ...OfferPromoBanner_promos\n    id\n  }\n}\n\nfragment OfferItem_offer on Offer {\n  id\n  title\n  guid\n  advertiser {\n    name\n    imageUrl\n  }\n  tags\n  paysReward\n  rewardLabel\n}\n\nfragment OfferPromoBanner_promos on OfferConnection {\n  edges {\n    node {\n      paysReward\n      id\n      imageUrl\n      desktopImageUrl\n      title\n      rewardLabel\n      slug\n      guid\n      advertiser {\n        name\n      }\n    }\n  }\n}\n\nfragment Offers_offers on OfferConnection {\n  edges {\n    node {\n      id\n      title\n      advertiser {\n        name\n      }\n      categories {\n        tag\n        name\n      }\n      tags\n      ...OfferItem_offer\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f44b9b127c39dab75016b13dee5d0c7b";

export default node;
